import { Component } from '@angular/core'

@Component({
  selector: 'flo-my-stuff-skeleton',
  templateUrl: './my-stuff-skeleton.component.html',
  styleUrls: ['./my-stuff-skeleton.component.scss']
})
export class MyStuffSkeletonComponent {}
